import { render, staticRenderFns } from "./arcPie.md?vue&type=template&id=110be372&"
import script from "./arcPie.md?vue&type=script&lang=js&"
export * from "./arcPie.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110be372')) {
      api.createRecord('110be372', component.options)
    } else {
      api.reload('110be372', component.options)
    }
    module.hot.accept("./arcPie.md?vue&type=template&id=110be372&", function () {
      api.rerender('110be372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Pie/arcPie.md"
export default component.exports